"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const autosave_1 = require("../../../../hooks/autosave");
const TaskPage_1 = require("../../base/TaskPage");
const RadioQuestion_1 = require("../../../components/input/radio/RadioQuestion");
const Section_1 = require("../../../components/section/Section");
const merlin_info_panels_1 = require("@travelnest/merlin.info-panels");
const constants_1 = require("../../../../tasks/constants");
const Spacer_1 = require("../../../components/spacer/Spacer");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const replaceIfExists = (restrictions, toReplace) => {
    const currentIndex = getTouristTaxRestrictionIndex(restrictions);
    if (currentIndex >= 0) {
        restrictions.splice(currentIndex, 1);
    }
    restrictions.push(toReplace);
    return restrictions;
};
const getTouristTaxRestrictionIndex = (restrictions) => restrictions.findIndex((r) => r.restriction_type === 'tourist tax');
const getTouristTaxRestriction = (restrictions) => {
    const idx = getTouristTaxRestrictionIndex(restrictions);
    if (idx >= 0) {
        return restrictions[idx];
    }
    return undefined;
};
exports.default = (props) => {
    const { property, viewState, update, lastSaved, getterError, updaterError } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const restrictions = (property === null || property === void 0 ? void 0 : property.restrictions) || [];
    const touristTaxRestriction = getTouristTaxRestriction(restrictions);
    return (React.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.TOURIST_TAX, property: property, viewState: viewState, lastSaved: lastSaved, getterError: getterError, updaterError: updaterError },
        React.createElement(TaskPage_1.TaskLayout, { width: 50 },
            React.createElement(HorizontalRule_1.HorizontalRule, null),
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            React.createElement(TaskPage_1.TaskColumn, null,
                React.createElement(Section_1.Section, { heading: "Tourist tax" },
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(merlin_info_panels_1.DidYouKnow, { colour: 'purple', id: 'tax-disclaimer', text: "Travelnest will not collect this tax on your behalf. You are responsible for collecting this tax from guests." }),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(RadioQuestion_1.YesNoRadioQuestion, { id: "tourist_tax", question: "Is your property subject to a tourist tax?", selected: (touristTaxRestriction === null || touristTaxRestriction === void 0 ? void 0 : touristTaxRestriction.allowed) || false, onChange: (_, v) => {
                            let restriction = restrictions['tourist tax'];
                            if (!restriction) {
                                restriction = {
                                    'restriction_type': 'tourist tax',
                                    'property': props.propertyId,
                                    'allowed': v,
                                    'charge': 0,
                                    'charge_type': 'none'
                                };
                            }
                            else {
                                restriction.allowed = v;
                            }
                            update({ restrictions: replaceIfExists([restriction], restriction) });
                        } }))))));
};
//# sourceMappingURL=TouristTaxPage.js.map